import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';
import style from '../Button/Button.module.scss.js';

const { componentTestLabel } = getTestLabels('ButtonAnchor');
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/ButtonAnchor/ButtonAnchor.tsx)
 *
 * A regular HTML anchor/link styled like a button.
 *
 * @param {string} size - (optional) Controls the component size affecting its height. Can be one of `normal` (default) or `small`.
 * @param {string} length - (optional) Controls the component width. Can be one of `normal` (default) or `full`.
 * @param {string} variant - (optional) The button style to mimic. Can be one of `primary` (default), `secondary`, `cart`, `inverse` or `negative` (`negative` is deprecated and `inverse` should be used instead).
 */
const ButtonAnchor = forwardRef((props, ref) => {
    const { className, variant = 'primary', length = 'normal', size = 'normal', children, ...otherProps } = props;
    return (jsx("a", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-btn'], style[`z-btn--${variant}`], {
            [style['z-btn--small']]: size === 'small',
            [style['z-btn--wide']]: variant !== 'cart' && length === 'full',
        }, className), children: children }));
});
ButtonAnchor.displayName = 'ButtonAnchor';

export { ButtonAnchor };
//# sourceMappingURL=ButtonAnchor.js.map
